import { Box } from "@mui/material"
import type { FC } from "react"
import React from "react"
import type { FieldArrayWithId } from "react-hook-form"

import { IMAGE_MIME_TYPES_WITH_PDF } from "@/components/upload/constants"
import FileInput from "@/components/upload/FileInput"
import CertificationDateField from "@/screens/Companies/edit/components/certification/components/forms/CertificationDateField"
import CertificationLocationSelect from "@/screens/Companies/edit/components/certification/components/forms/CertificationLocationSelect"
import CertificationTypeSelect from "@/screens/Companies/edit/components/certification/components/forms/CertificationTypeSelect"
import { CERTIFICATION_ALLOWED_TYPES_LABEL } from "@/screens/Companies/edit/components/certification/constants"
import type { UpdateCompanyCertificationFormValues } from "@/screens/Companies/edit/components/certification/schema/CompanyCertificationSchema"

interface CertificationFormProps {
  companyId: string
  file?: File
  fields: FieldArrayWithId[]
  onMarkFileAsNeedRemoval: () => void
  fileFetching?: boolean
}

const EditCertificationForm: FC<CertificationFormProps> = ({
  companyId,
  file,
  onMarkFileAsNeedRemoval,
  fields,
  fileFetching,
}) => {
  return (
    <form>
      <CertificationTypeSelect name='certificationType' disabled label='Certification Type' />
      <CertificationLocationSelect companyId={companyId} name='locationId' disabled label='Location' />

      {fields.map((field, index) => {
        return (
          <div key={field.id}>
            <Box className='flex justify-between gap-x-4'>
              <CertificationDateField name={`companyCertifications.${index}.effectiveDate`} label='Effective Date' />
              <CertificationDateField name={`companyCertifications.${index}.expirationDate`} label='Expiration Date' />
            </Box>

            <FileInput<UpdateCompanyCertificationFormValues>
              title='Certification Document'
              required
              fileFetching={fileFetching}
              fileData={file}
              name={`companyCertifications.${index}.image`}
              className='mt-4'
              onChange={onMarkFileAsNeedRemoval}
              allowedMimeTypes={IMAGE_MIME_TYPES_WITH_PDF}
              allowedTypesLabel={CERTIFICATION_ALLOWED_TYPES_LABEL}
            />
          </div>
        )
      })}
    </form>
  )
}

export default EditCertificationForm
